import { Text } from '@daily/shared/components/Text';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useRenderBreakoutsInterstitialScreen } from '../../contexts/BreakoutsProvider';
import { useBreakoutSessionState } from '../BreakoutRooms/hooks/useBreakoutSessionState';
import { BreakoutCountdown } from './BreakoutCountdown';

export const BreakoutStatus: React.FC = () => {
  const { t } = useTranslation();
  const { currentBreakoutRoom, invitedBreakoutRoom, joinedState } =
    useBreakoutSessionState();
  const isJoiningBreakout = useRenderBreakoutsInterstitialScreen();

  const isInvited = joinedState === 'invited' && !isJoiningBreakout;

  const statusText = useMemo(() => {
    const invitedRoomName = t('breakouts.roomWithName', {
      name: invitedBreakoutRoom?.name,
    });
    if (isInvited)
      return t('breakouts.statusPleaseJoin', { room: invitedRoomName });
    if (currentBreakoutRoom?.name)
      return t('breakouts.roomWithName', {
        name: currentBreakoutRoom?.name,
      });
    return t('breakouts.mainRoom');
  }, [currentBreakoutRoom?.name, invitedBreakoutRoom?.name, isInvited, t]);

  return (
    <div className="breakout-status">
      <Text>{t('breakouts.breakoutSession')}</Text>
      {statusText && <Text variant="strong">{statusText}</Text>}
      <BreakoutCountdown />
      <style jsx>{`
        .breakout-status {
          display: flex;
          gap: 12px;
        }
      `}</style>
    </div>
  );
};
